import React, { Component } from "react";
import PropTypes from "prop-types";
import { SaveOutlined } from "@ant-design/icons";

// Components 
import Input from "@cores/components/Input";
import TimePicker from "@cores/components/time-picker";
import DatePicker from "@cores/components/date-picker";
import UserAutoComplete from "@cores/components/auto-complete/user-account";

// Libs
import { Row, Col } from "reactstrap";
import { reduxForm } from "redux-form";
import { Button, Form } from "antd";
import { connect } from "react-redux";

// helper 
import { createSubmitAction } from "@/helpers";
import { createAttendance } from "../../../actions";
import { createAttendanceSubmitRules } from "../../../helpers";
import { ATTENDANCE_CREATE_REQUEST } from "../../../constants";

class CreateAttendance extends Component {

  onSubmit = (values, dispatch) => {
    const { onDismiss } = this.props;
    return createSubmitAction(
      createAttendanceSubmitRules(values),
      createAttendance
    )(values, dispatch).then((data) => {
      if (data.error == null) {
        onDismiss();
      }
    });
  }

  render() {
    const { 
      loading,
      userId,
      handleSubmit,
      isCurrentUserPage,
      isAllowToCrateAttendanceForOther,
    } = this.props;
    const columns = isAllowToCrateAttendanceForOther ? 6 : 12;
    return (
      <Form onFinish={handleSubmit(this.onSubmit)} layout="vertical">
        <Row>
          {(isAllowToCrateAttendanceForOther && !isCurrentUserPage) && (
            <Col md="6" sm="12" xs="12">
              <UserAutoComplete 
                name="userId"
                label="User"
                ids={[userId]}
              />
            </Col>
          )}
          <Col md={columns} xs="12">
            <DatePicker
              required
              name="attandanceDate"
              label="Date"
              showFutureDates={false}  
              numberDayOfDisabledFuture={1}
            />
          </Col>
          <Col md="6" sm="12" xs="12">
            <TimePicker 
              label="Time In" 
              name="checkInTime"
            />
          </Col>
          <Col md="6" sm="12" xs="12">
            <TimePicker 
              label="Time Out" 
              name="checkOutTime"
            />
          </Col>
          <Col md="12" sm="12" xs="12">
            <Input 
              required
              label="Reason"
              name="description"
              type="TextArea"
              rows="4"
            />
          </Col>
          <Col md="12" sm="12" xs="12">
            <Button 
              ghost
              type="primary"
              htmlType="submit"
              loading={loading}
              icon={<SaveOutlined />}
              className="float-right" 
            >
              Save
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

CreateAttendance.propTypes = {
  label: PropTypes.string,
  userId: PropTypes.number,
  loading: PropTypes.bool,
  onDismiss: PropTypes.func,
  handleSubmit: PropTypes.func,
  editAttendance: PropTypes.func,
  isCurrentUserPage: PropTypes.bool,
  isAllowToCrateAttendanceForOther: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => {
  const { userId } = ownProps;
  return {
    loading: state.request[ATTENDANCE_CREATE_REQUEST],
    initialValues: {
      userId,
    },
  };
};

export default connect(mapStateToProps)(reduxForm({
  enableReinitialize: true,
})(CreateAttendance));